import React from 'react'
import { breakpoints } from 'ui/acro'
import PlaylistResultCard from '../CardStyles/PlaylistResultCard'
import Carousel from 'components_v2/Home/SignedIn/common/components/Carousel/Carousel'

const PlaylistsResultsCarousel = ({ data }) => {
  const playlistsData = data && data.playlists.top
  return (
    <Carousel
      card={PlaylistResultCard}
      carouselTitle={'PlaylistsTopResults'}
      data={playlistsData}
      breakpoints={{
        0: {
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        320: {
          slidesPerView: 1.4,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        375: {
          slidesPerView: 1.7,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        [breakpoints[1]]: {
          slidesPerView: 3.4,
          spaceBetween: 20,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        768: {
          slidesPerView: 5,
          spaceBetween: 20,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        [breakpoints[2]]: {
          slidesPerView: 5,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        }
      }}
    />
  )
}

export default PlaylistsResultsCarousel
